import { $logger } from '../logger/logger.js';
import { isNamedPlaceHolder } from './match-point-regex.js';
import { NamedPlaceHolder } from './named-placeholder.js';

/**
 *  NonFunction config的Map
 *
 * Map的key可能是普通字符串，也肯能是named parameter格式的字符串
 * ```
 *  {
 *     ['context-insert-comment': uiConfigObject ],
 *     ['new-:editor-:mode': uiConfigObject ],
 *  }
 * ```
 * @public
 */
class NonFunctionConfigMap {
    constructor() {
        this.configs = new Map();
        this.namedPlaceHolder = new NamedPlaceHolder();
    }
    /**
     * 设置NonFunction config key对应的value
     * @param key - config key字符串
     * @param config - config value
     */
    set(key, config) {
        this.configs.set(key, config);
        // 记住named parameter格式的字符串
        if (isNamedPlaceHolder(key)) {
            this.namedPlaceHolder.addMatchPoint(key);
        }
    }
    /**
     * 从管理器中删除某个配置
     * 只需要处理普通字符串key
     * @param key - 配置 key
     */
    remove(key) {
        if (!this.configs.has(key)) {
            $logger.warn(`The config "${key}" does not exist, thus ignored.`);
            return;
        }
        this.configs.delete(key);
    }
    /**
     * 查询是否存在非方法类型UI配置
     * 需要同时处理普通字符串key和named parameter格式的字符串key
     * @param key - 配置 key
     */
    has(key) {
        // 普通字符串直接查询
        let isContain = this.configs.has(key);
        if (isContain) {
            return isContain;
        }
        // named place holder匹配
        const matchPoint = this.namedPlaceHolder.getMatchPoint(key);
        if (matchPoint) {
            isContain = true;
        }
        return isContain;
    }
    /**
     * 按名字，获取非方法类型UI配置
     * 需要同时处理普通字符串key和named parameter格式的字符串key
     * @param key - 配置 key
     */
    get(key) {
        // 普通字符串直接查询
        let retValue = this.configs.get(key);
        if (retValue) {
            return retValue;
        }
        // named place holder匹配
        const matchPoint = this.namedPlaceHolder.getMatchPoint(key);
        if (matchPoint) {
            const configValue = this.configs.get(matchPoint);
            if (configValue) {
                retValue = Object.assign(Object.assign({}, configValue), { name: key });
            }
        }
        return retValue;
    }
    /**
     * 获取所有config的key
     * @returns string[]
     */
    getAllKeys() {
        const keys = [];
        for (const key of this.configs.keys()) {
            keys.push(key);
        }
        return keys;
    }
}

export { NonFunctionConfigMap };
//# sourceMappingURL=non-function-config-map.js.map
